export const PROPERTY_TYPES = {
  STANDARD_RENTAL: 0,
  MULTI_RENTAL: 1
};

export const getPropertyTypeLabel = (type) => {
  // Handle string values from API
  if (typeof type === 'string') {
    switch (type) {
      case 'single_rental':
        return 'Single Rental';
      case 'multi_rental':
        return 'Multi Rental';
      case 'standard_rental':
        return 'Standard Rental';
      default:
        return 'Unknown';
    }
  }

  // Handle numeric values (legacy support)
  switch (type) {
    case PROPERTY_TYPES.ROOMING_HOUSE:
      return 'Rooming House';
    case PROPERTY_TYPES.STANDARD_RENTAL:
      return 'Standard Rental';
    default:
      return 'Unknown';
  }
};

export const isRoomingHouse = (property) => {
  return property.type === PROPERTY_TYPES.ROOMING_HOUSE;
};

export const isStandardRental = (property) => {
  return property.type === PROPERTY_TYPES.STANDARD_RENTAL;
};

// ─── Property Image Types ────────────────────────────────────────────────────

export const IMAGE_TYPE_CONFIG = {
  profile:    { label: 'Profile',    badgeClass: 'bg-success text-white',    filterLabel: 'Profile' },
  gallery:    { label: 'Gallery',    badgeClass: 'bg-primary text-white',    filterLabel: 'Gallery' },
  exterior:   { label: 'Exterior',   badgeClass: 'bg-warning text-dark',     filterLabel: 'Exterior' },
  interior:   { label: 'Interior',   badgeClass: 'bg-info text-white',       filterLabel: 'Interior' },
  floor_plan: { label: 'Floor Plan', badgeClass: 'bg-secondary text-white',  filterLabel: 'Floor Plan' },
};

export const IMAGE_TYPE_ORDER = ['profile', 'gallery', 'exterior', 'interior', 'floor_plan'];

export const getImageTypeConfig = (imageType) =>
  IMAGE_TYPE_CONFIG[imageType] || { label: imageType || 'Unknown', badgeClass: 'bg-secondary text-white', filterLabel: imageType };

export const IMAGE_TYPE_OPTIONS = IMAGE_TYPE_ORDER.map((key) => ({
  value: key,
  ...IMAGE_TYPE_CONFIG[key],
}));
